import { integerPartLengthExceeds, isPrecise, isNumberEmpty, isNegative } from 'utils/utils';

// for bracket create and update field validation
export const ValidateFields = (bracketInfo, handleError) => {
  if (!bracketInfo?.name) {
    handleError('name', 'Please enter bracket name');
  }
  // commented checks are because the fields are now readonly

  const bracketWPrice = isNumberEmpty(bracketInfo?.wholesalePrice);
  if (bracketWPrice) {
    handleError('wholesalePrice', 'Please enter bracket price');
  }

  let isNegativeCheck = isNegative(bracketInfo?.wholesalePrice);
  if (isNegativeCheck) {
    handleError('wholesalePrice', 'Please enter positive value for this price');
  }
  const bracketCPrice = isNumberEmpty(bracketInfo?.contractorPrice);
  if (bracketCPrice) {
    handleError('contractorPrice', 'Please enter bracket price');
  }

  isNegativeCheck = isNegative(bracketInfo?.contractorPrice);
  if (isNegativeCheck) {
    handleError('contractorPrice', 'Please enter positive value for this price');
  }
  const bracketRPrice = isNumberEmpty(bracketInfo?.retailerPrice);
  if (bracketRPrice) {
    handleError('retailerPrice', 'Please enter bracket price');
  }

  isNegativeCheck = isNegative(bracketInfo?.retailerPrice);
  if (isNegativeCheck) {
    handleError('retailerPrice', 'Please enter positive value for this price');
  }
  const bracketMPrice = isNumberEmpty(bracketInfo?.manufacturerPrice);
  if (bracketMPrice) {
    handleError('manufacturerPrice', 'Please enter bracket price');
  }

  isNegativeCheck = isNegative(bracketInfo?.manufacturerPrice);
  if (isNegativeCheck) {
    handleError('manufacturerPrice', 'Please enter positive value for this price');
  }

  // -----------------------------------------------------------
  let maxDigitBeforeDecimal = integerPartLengthExceeds(bracketInfo?.wholesalePrice, 3);

  if (maxDigitBeforeDecimal) {
    handleError('wholesalePrice', 'Maximum 3 digits allowed before decimal i.e xxx.xx');
  }

  let maxDigitAfterDecimal = isPrecise(bracketInfo?.wholesalePrice, 2);
  if (maxDigitAfterDecimal) {
    handleError('wholesalePrice', 'Please enter 2 digits after decimal i.e xxx.xx');
  }
  // -----------------------------------------------------------
  maxDigitBeforeDecimal = integerPartLengthExceeds(bracketInfo?.contractorPrice, 3);

  if (maxDigitBeforeDecimal) {
    handleError('contractorPrice', 'Maximum 3 digits allowed before decimal i.e xxx.xx');
  }

  maxDigitAfterDecimal = isPrecise(bracketInfo?.contractorPrice, 2);
  if (maxDigitAfterDecimal) {
    handleError('contractorPrice', 'Please enter 2 digits after decimal i.e xxx.xx');
  }
  // -----------------------------------------------------------
  maxDigitBeforeDecimal = integerPartLengthExceeds(bracketInfo?.manufacturerPrice, 3);

  if (maxDigitBeforeDecimal) {
    handleError('manufacturerPrice', 'Maximum 3 digits allowed before decimal i.e xxx.xx');
  }

  maxDigitAfterDecimal = isPrecise(bracketInfo?.manufacturerPrice, 2);
  if (maxDigitAfterDecimal) {
    handleError('manufacturerPrice', 'Please enter 2 digits after decimal i.e xxx.xx');
  }
  // -----------------------------------------------------------
  maxDigitBeforeDecimal = integerPartLengthExceeds(bracketInfo?.retailerPrice, 3);

  if (maxDigitBeforeDecimal) {
    handleError('retailerPrice', 'Maximum 3 digits allowed before decimal i.e xxx.xx');
  }

  maxDigitAfterDecimal = isPrecise(bracketInfo?.retailerPrice, 2);
  if (maxDigitAfterDecimal) {
    handleError('retailerPrice', 'Please enter 2 digits after decimal i.e xxx.xx');
  }

  if (
    bracketInfo?.name &&
    bracketInfo?.wholesalePrice &&
    bracketInfo?.contractorPrice &&
    bracketInfo?.manufacturerPrice &&
    bracketInfo?.retailerPrice &&
    bracketInfo?.type &&
    bracketInfo?.material &&
    !maxDigitBeforeDecimal &&
    !maxDigitAfterDecimal &&
    !isNegativeCheck
  ) {
    return true;
  }
  return false;
};
